export function fmtMoney(cents: number, currency = 'USD'): string {
  const symbol = currency === 'CNY' ? '¥' : '$'
  return symbol + (cents / 100).toLocaleString(currency === 'CNY' ? 'zh-CN' : 'en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function fmtTime(unixSec: number | null | undefined): string {
  if (!unixSec) return '—'
  return new Date(unixSec * 1000).toISOString().slice(0, 16).replace('T', ' ')
}

export function fmtRelative(unixSec: number | null | undefined): string {
  if (!unixSec) return '—'
  const ms = Date.now() - unixSec * 1000
  const sec = Math.floor(ms / 1000)
  // Minute-level granularity is enough for relative timestamps in lists —
  // sub-minute precision adds noise without value (rows move while you're
  // reading them). Future-dated values (clock skew etc.) collapse to the
  // same "just now" rather than negative numbers.
  if (sec < 60) return 'just now'
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min}m ago`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}h ago`
  const d = Math.floor(hr / 24)
  if (d < 30) return `${d}d ago`
  return new Date(unixSec * 1000).toISOString().slice(0, 10)
}
